<ng-container *ngFor="let alert of alertRepository.alerts$ | async">
  <common-alert [alert]="alert"> </common-alert>
</ng-container>
